import parseDate, { parseISODate } from "./parseDate";

export enum CASE {
  Nominative, // Именительный
  Genitive, // Родительный
  Dative, // Дательный
  Accusative, // Винительный
  Instrumental, // Творительный
  Prepositional, // Предложный
}

export const l10nMonth = ([
  ['январь', 'января', 'январю', 'январь', 'январём', 'январе'],
  ['февраль', 'февраля', 'февралю', 'февраль', 'февралём', 'феврале'],
  ['март', 'марта', 'марту', 'март', 'мартом', 'марте'],
  ['апрель', 'апреля', 'апрелю', 'апрель', 'апрелем', 'апреле'],
  ['май', 'мая', 'маю', 'май', 'маем', 'мае'],
  ['июнь', 'июня', 'июню', 'июнь', 'июнем', 'июне'],
  ['июль', 'июля', 'июлю', 'июль', 'июлем', 'июле'],
  ['август', 'августа', 'августу', 'августа', 'августом', 'августе'],
  ['сентябрь', 'сентября', 'сентябрю', 'сентябрь', 'сентябрём', 'сентябре'],
  ['октябрь', 'октября', 'октябрю', 'октябрь', 'октябрём', 'октябре'],
  ['ноябрь', 'ноября', 'ноябрю', 'ноябрь', 'ноябрём', 'ноябре'],
  ['декабрь', 'декабря', 'декабрю', 'декабрь', 'декабрём', 'декабре'],
]) as const;

export type MonthNumber = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
export const parseMonth = (str: string): MonthNumber => {
  str = str.toLowerCase().trim();
  for (let i = 0; i < l10nMonth.length; i++) {
    const month = l10nMonth[i];
    for (let j = 0; j < month.length; j++) {
      if (str === month[j]) return i + 1 as MonthNumber;
    }
  }
  return null;
}

export const formatMonth = (date: Date, l10nCase?: CASE) => {
  return l10nMonth[date.getMonth()][l10nCase || 0];
}

export const formatDateMonth = (date: Parameters<typeof parseISODate>[0], l10nCase?: CASE) => {
  date = parseISODate(date);
  if (!date || isNaN(+date)) return null;
  const str = `${formatMonth(date, l10nCase)} ${date.getFullYear()}`;
  return str.charAt(0).toUpperCase() + str.slice(1)
}
